
import { BlogContent } from '@/components/admin/blog/BlogContent';
import { BlogErrorState } from '@/components/admin/blog/BlogErrorState';
import { useBlogPosts } from '@/hooks/admin/blog/useBlogPosts';
import { useBlogOperations } from '@/hooks/admin/blog/useBlogOperations';

const BlogAdmin = () => {
  const {
    posts,
    isLoading,
    error,
    searchQuery,
    setSearchQuery,
  } = useBlogPosts();

  const {
    handleCreatePost,
    handleEditPost,
    handleViewPost,
    handleDuplicatePost,
    handleDeletePost,
  } = useBlogOperations();

  if (error) {
    return <BlogErrorState error={error} />;
  }

  return (
    <div className="container mx-auto px-4 py-8">
      <BlogContent
        posts={posts}
        isLoading={isLoading}
        searchQuery={searchQuery}
        setSearchQuery={setSearchQuery}
        onCreatePost={handleCreatePost}
        onEditPost={handleEditPost}
        onViewPost={handleViewPost}
        onDuplicatePost={handleDuplicatePost}
        onDeletePost={handleDeletePost}
      />
    </div>
  );
};

export default BlogAdmin;
